module.exports = __webpack_public_path__ + "img/dingwei-phone-un.43cc9e29.png";